import { CLIENT_CONFIG, CURRENT_CLIENT } from '@/constants'

import type { PaneResponsiveCardGridMaxColumns } from '@/components/layout/pane-responsive-card-grid-classes'

type ClientWithCardListLayout = {
  layout?: {
    entityCardListMaxColumns?: PaneResponsiveCardGridMaxColumns
  }
}

const TENANT_DEFAULT_MAX_COLUMNS: Partial<Record<string, PaneResponsiveCardGridMaxColumns>> = {
  talentco: 2,
  lortsmith: 3,
}

export function resolveEntityCardListMaxColumns(
  override?: PaneResponsiveCardGridMaxColumns,
): PaneResponsiveCardGridMaxColumns {
  if (override != null) return override

  const fromConfig = (CURRENT_CLIENT as ClientWithCardListLayout).layout?.entityCardListMaxColumns
  if (fromConfig != null) return fromConfig

  return TENANT_DEFAULT_MAX_COLUMNS[CLIENT_CONFIG] ?? 4
}
